var _circle, _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgRocket(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 78,
    height: 78,
    viewBox: "0 0 78 78",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 39,
    cy: 39,
    r: 39,
    fill: "#3DD0C4"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_266_4030)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M52.0274 25.977C51.9159 25.8648 51.7821 25.7773 51.6346 25.7203C51.4871 25.6633 51.3292 25.6381 51.1713 25.6462C35.3898 26.4697 29.56 40.5277 29.5038 40.6695C29.4214 40.874 29.401 41.0982 29.445 41.3142C29.489 41.5302 29.5955 41.7285 29.7513 41.8845L36.1154 48.2486C36.2721 48.4051 36.4715 48.5119 36.6887 48.5555C36.9058 48.5991 37.131 48.5777 37.336 48.4939C37.4766 48.4365 51.4593 42.5415 52.3525 26.8342C52.3615 26.6765 52.3372 26.5187 52.2812 26.371C52.2252 26.2233 52.1387 26.089 52.0274 25.977ZM42.8406 38.3407C42.526 38.6555 42.1251 38.8698 41.6886 38.9567C41.2521 39.0436 40.7997 38.9991 40.3885 38.8288C39.9773 38.6585 39.6259 38.3701 39.3786 38.0001C39.1314 37.6301 38.9994 37.195 38.9994 36.75C38.9994 36.3049 39.1314 35.8699 39.3786 35.4999C39.6259 35.1299 39.9773 34.8415 40.3885 34.6712C40.7997 34.5009 41.2521 34.4564 41.6886 34.5433C42.1251 34.6301 42.526 34.8445 42.8406 35.1592C43.2624 35.5812 43.4994 36.1534 43.4994 36.75C43.4994 37.3466 43.2624 37.9188 42.8406 38.3407Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M26.7521 46.6995C27.0489 46.4007 27.4016 46.1635 27.7903 46.0013C28.1789 45.8392 28.5957 45.7554 29.0168 45.7546C29.4378 45.7539 29.8549 45.8363 30.2441 45.9971C30.6333 46.158 30.9869 46.394 31.2846 46.6918C31.5824 46.9895 31.8184 47.3431 31.9792 47.7323C32.14 48.1214 32.2224 48.5385 32.2217 48.9596C32.221 49.3807 32.1372 49.7975 31.975 50.1861C31.8129 50.5747 31.5756 50.9275 31.2769 51.2242C30.027 52.4741 25.5 52.5 25.5 52.5C25.5 52.5 25.5 47.9482 26.7521 46.6995Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M37.1515 28.1336C35.5659 27.8576 33.9371 27.9675 32.4029 28.4539C30.8687 28.9403 29.4741 29.789 28.3371 30.9281C27.7355 31.5353 27.2124 32.2157 26.7801 32.9531C26.6536 33.168 26.602 33.4189 26.6336 33.6664C26.6651 33.9138 26.778 34.1437 26.9545 34.32L29.1921 36.5587C31.2714 33.2589 33.9751 30.397 37.1515 28.1336Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M49.8665 40.8484C50.1425 42.434 50.0326 44.0628 49.5462 45.597C49.0598 47.1312 48.2112 48.5257 47.072 49.6627C46.4648 50.2644 45.7845 50.7875 45.047 51.2197C44.8321 51.3463 44.5812 51.3979 44.3338 51.3663C44.0863 51.3347 43.8564 51.2218 43.6802 51.0454L41.4414 48.8077C44.7412 46.7285 47.6032 44.0247 49.8665 40.8484Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_266_4030"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 27,
    height: 27,
    fill: "white",
    transform: "translate(25.5 25.5)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRocket);
export default __webpack_public_path__ + "static/media/rocket.90c92073419020ed5a836013a2b551a2.svg";
export { ForwardRef as ReactComponent };